import { LoaderV2, LoaderMode, LoaderTheme } from "components/common/LoaderV2/LoaderV2";

const budgetTexts = [
  "Processing your budget…",
  "Analyzing costs…",
  "Calculating totals…",
  "Applying contingencies…",
  "Validating line items…",
  "Finalizing calculations…",
  "Preparing breakdown…",
  "Almost there…",
];

export const BudgetLoader = () => {
  return (
    <div className="w-full h-full flex items-center justify-center p-8">
      <div className="flex flex-col items-center gap-4">
        <LoaderV2
          mode={LoaderMode.inline}
          theme={LoaderTheme.brand}
          size="md"
          rotatingTexts={budgetTexts}
          textClassName="text-muted-foreground text-sm"
        />
      </div>
    </div>
  );
};
